var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoligonoETrecho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.425,
    viewBox: "0 0 18 18.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-5.978 -5.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_103",
    "data-name": "Caminho 103",
    d: "M23.978,18.82l-8.971,5.222-.029-.014-9-5.208,3.453-1.995,3.439-2.01,2.08-1.2.028.014,2.109,1.217,3.439,1.981Z",
    fill: "#ffbb04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_104",
    "data-name": "Caminho 104",
    d: "M23.978,14.83l-3.452,2-5.519,3.212-.029-.014-5.547-3.2-3.453-2,3.453-2L14.95,9.622l.028.014,5.548,3.2Z",
    fill: "#ff7900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_105",
    "data-name": "Caminho 105",
    d: "M23.978,10.839l-3.452,1.995-3.439,2.01-2.08,1.2-.029-.015L12.87,14.815,9.431,12.834,5.978,10.839,14.95,5.617l.028.014Z",
    fill: "#004692"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_106",
    "data-name": "Caminho 106",
    d: "M23.978,14.83l-3.452,2,3.452,1.995-8.971,5.222-.029-.014V5.631l9,5.208-3.452,1.995Z",
    fill: "#282828",
    opacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoligonoETrecho);
export default __webpack_public_path__ + "static/media/poligono-e-trecho.94193fd0f81b6dce6698dcd367b618a5.svg";
export { ForwardRef as ReactComponent };